import React, { useState, useCallback } from 'react';

import {
    required, minLength, maxLength, minValue, maxValue,
    number, regex, email, choices,
    TabbedForm, FormTab, DeleteButton, useRefresh, AutocompleteInput,
    Edit, SimpleForm, TextInput, RichTextField,
    ReferenceInput, SelectInput, EditButton, NumberField,
    DateInput, BooleanInput, NumberInput, ImageInput, ImageField,
    ReferenceManyField, ReferenceField, Datagrid, TextField, BooleanField, FormDataConsumer
} from 'react-admin';
import { useForm } from 'react-final-form';
import { useStyles } from "../../formStyles";

export const AddressFields = ({ formData, ...rest }) => {
    const form = useForm();
    const classes = useStyles({});
    return (
        <div >
            <ReferenceInput variant="outlined" label="Country" source="countryId" reference="countries"
                onChange={(v) => {
                    console.log(v);
                    form.change("stateId", 0);
                    form.change("cityId", 0);
                    form.change("districtId", 0);
                }}
                validate={required()} 
                sort={{ field: 'name', order: 'ASC' }}
                fullWidth={true} perPage={500} >
                <AutocompleteInput optionText="name" />

            </ReferenceInput>
            {/* <ReferenceInput perPage={25} sort={{ field: 'name', order: 'ASC' }}
                    filterToQuery={searchText => ({ 'name~like': searchText })}
                    label="Corporate Name" source="corporateId" reference="corporates" fullWidth={true} formClassName={classes.last_inline_input}>
                    <AutocompleteInput optionText="name" variant="outlined" shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }} />
                  </ReferenceInput> */}

            <ReferenceInput variant="outlined" label="State" source="stateId"
                reference="states" perPage={500}
                filter={{countryId: formData.pCountryId}}
                onChange={(v) => {
                    //console.log(v);
                    form.change("cityId", 0);
                    form.change("districtId", 0);
                }}
                validate={required()} 
                sort={{ field: 'name', order: 'ASC' }}
                shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }}
                fullWidth={true} >
                {/* <SelectInput validate={required()} optionText="name" /> */}
                <AutocompleteInput validate={required()} optionText="name" variant="outlined" shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }}  fullWidth={true} className={classes.two_4_input}/>
            </ReferenceInput>

            <ReferenceInput variant="outlined" label="District" source="districtId"
                reference="districts" perPage={500}
                filter={{stateId: formData.pStateId}}
                onChange={(v) => {
                    //console.log(v);
                    form.change("cityId", 0);
                }}
                validate={required()} 
                sort={{ field: 'name', order: 'ASC' }}
                shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }}
                fullWidth={true} >
                {/* <SelectInput validate={required()} optionText="name" /> */}
                <AutocompleteInput validate={required()} optionText="name" variant="outlined" shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }}  fullWidth={true} className={classes.two_4_input}/>
            </ReferenceInput>


            <ReferenceInput variant="outlined" label="City"
              filter={{districtId: formData.pDistrictId}}
              sort={{ field: 'name', order: 'ASC' }}
                validate={required()} source="cityId" reference="cities" perPage={500}
                shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }}
                fullWidth={true} >
                {/* <SelectInput  validate={required()} optionText="name" /> */}
                <AutocompleteInput validate={required()} optionText="name" variant="outlined" shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }}  fullWidth={true} className={classes.two_4_input}/>
            </ReferenceInput>
        </div>
    )
}
